<template>
  <div class="introduction">
    <riseup-header/>
    <div class="intake-container">
      <div class="title">הצטרפות לשירות</div>
      <div class="greeting">
        כדי לצרף אותך לשירות נצטרך כמה פרטים ונשלח לך   <span class="wa-verification">קוד אימות אישי ב-WhatsApp.</span>
      </div>
      <enter-details :action="generateCodeAndProceed"
                     :error="serverErrors.generateCode"
                     :reset-error="() => resetError('generateCode')"/>

      <div class="privacy-message">לעולם לא נמסור את הפרטים שלך לאף צד שלישי.</div>
      <support-footer/>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import BaseUI from 'base-ui';
import EnterDetails from '../../../../../../base-components/EnterDetails.vue';
import Segment from '../../../../../../Segment';
import RiseupHeader from '../../../../../../base-components/app-header/RiseupHeader.vue';

export default {
  name: 'Introduction',
  components: {
    EnterDetails,
    SupportFooter: BaseUI.SupportFooter,
    RiseupHeader,
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('RegistrationEntered');
    Segment.trackUserGotToPixel('RE');
  },
  computed: {
    ...mapState('signup', ['phoneNumber', 'firstName', 'lastName', 'serverErrors']),
  },
  methods: {
    ...mapActions('signup', ['generateCode']),
    ...mapMutations('signup', ['setFirstName', 'setLastName', 'setPhoneNumber', 'resetError']),
    async generateCodeAndProceed(firstName, lastName, phoneNumber) {
      await this.setFirstName(firstName);
      await this.setLastName(lastName);
      await this.setPhoneNumber(phoneNumber);
      Segment.trackUserInteraction('GenerateCodeClicked', {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber,
      });
      await this.generateCode();
      this.next();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';

.introduction {
  @include white-page-frame;

  .intake-container {
    @include responsive-padding;
    margin-top: 30px;

    .generate-code-button {
      width: 100%;
    }

    .title {
      font-family: GretaSans;
      font-size: 24px;
      line-height: 1.2;
      display: inline-block;
      width: 100%;
      margin-bottom: 20px;
    }

    .greeting {
      font-size: 18px;
      color: $riseup_black;
      line-height: 1.5em;
      margin-bottom: 32px;

      .wa-verification {
        font-weight: bold;
      }
    }

    .privacy-message {
      font-size: 16px;
      color: $riseup_black;
      line-height: 24px;
      margin: 30px 0 15px;
    }
  }
}

</style>
